(function () {
  if (window.lpDietCokeLandingReady) return;
  window.lpDietCokeLandingReady = true;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-lp-diet-coke-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    items.forEach(function (item) {
      if (item.dataset.lpDietCokeRevealReady === 'true') return;
      item.dataset.lpDietCokeRevealReady = 'true';
      observer.observe(item);
    });
  }

  function initFizz(root) {
    if (prefersReducedMotion) return;

    var scope = root || document;
    var canvases = scope.querySelectorAll('[data-lp-diet-coke-fizz-canvas]');

    canvases.forEach(function (canvas) {
      if (canvas.dataset.lpDietCokeFizzReady === 'true') return;
      if (canvas.getAttribute('data-lp-diet-coke-fizz-enabled') === 'false') return;

      var ctx = canvas.getContext('2d');
      var stage = canvas.closest('[data-lp-diet-coke-fizz-stage]');
      if (!ctx || !stage) return;

      canvas.dataset.lpDietCokeFizzReady = 'true';
      var bubbles = [];

      function resize() {
        var rect = stage.getBoundingClientRect();
        var ratio = window.devicePixelRatio || 1;
        canvas.width = Math.max(1, Math.floor(rect.width * ratio));
        canvas.height = Math.max(1, Math.floor(rect.height * ratio));
        canvas.style.width = rect.width + 'px';
        canvas.style.height = rect.height + 'px';
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      }

      function makeBubble() {
        var width = canvas.clientWidth || 600;
        var height = canvas.clientHeight || 800;
        return {
          x: Math.random() * width,
          y: height + Math.random() * 20,
          r: Math.random() * 4 + 1.5,
          speed: Math.random() * 0.5 + 0.25,
          alpha: Math.random() * 0.5 + 0.15,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: (Math.random() - 0.5) * 0.035
        };
      }

      function initBubbles() {
        resize();
        bubbles = Array.from({ length: 50 }, makeBubble);
        bubbles.forEach(function (bubble) {
          bubble.y = Math.random() * (canvas.clientHeight || 800);
        });
      }

      function draw() {
        var width = canvas.clientWidth;
        var height = canvas.clientHeight;
        ctx.clearRect(0, 0, width, height);

        bubbles.forEach(function (bubble) {
          bubble.y -= bubble.speed;
          bubble.wobble += bubble.wobbleSpeed;
          bubble.x += Math.sin(bubble.wobble) * 0.35;

          if (bubble.y < -10) {
            Object.assign(bubble, makeBubble());
          }

          ctx.beginPath();
          ctx.arc(bubble.x, bubble.y, bubble.r, 0, Math.PI * 2);
          ctx.strokeStyle = 'rgba(255,255,255,' + (bubble.alpha * 0.7) + ')';
          ctx.lineWidth = 0.8;
          ctx.stroke();
          ctx.fillStyle = 'rgba(255,255,255,' + (bubble.alpha * 0.12) + ')';
          ctx.fill();
        });

        window.requestAnimationFrame(draw);
      }

      initBubbles();
      draw();
      window.addEventListener('resize', resize, { passive: true });
    });
  }

  function initTicker(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('[data-lp-diet-coke-ticker-track]');

    tracks.forEach(function (track) {
      var wrap = track.closest('.lp-diet-coke__ticker-wrap');
      var sourceGroup = track._lpDietCokeSourceGroup || track.querySelector('[data-lp-diet-coke-ticker-group]');
      if (!wrap || !sourceGroup) return;

      track._lpDietCokeSourceGroup = sourceGroup.cloneNode(true);

      function rebuildTicker() {
        var baseGroup = track._lpDietCokeSourceGroup.cloneNode(true);
        track.innerHTML = '';
        track.appendChild(baseGroup);

        var groupWidth = baseGroup.scrollWidth;
        var wrapWidth = wrap.clientWidth;
        if (!groupWidth || !wrapWidth) return;

        var groupCount = Math.max(2, Math.ceil((wrapWidth + groupWidth) / groupWidth) + 1);
        for (var i = 1; i < groupCount; i += 1) {
          var clone = track._lpDietCokeSourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }

        track.style.setProperty('--lp-diet-coke-ticker-distance', groupWidth + 'px');
        track.style.setProperty('--lp-diet-coke-ticker-duration', Math.max(18, groupWidth / 54) + 's');
      }

      rebuildTicker();

      if (track._lpDietCokeTickerReady === 'true') return;
      track._lpDietCokeTickerReady = 'true';

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(rebuildTicker, 150);
      }, { passive: true });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(rebuildTicker).catch(function () {});
      }
    });
  }

  function showCartPill(count) {
    var pill = document.querySelector('[data-lp-diet-coke-cart-pill]');
    if (!pill) return;

    var badge = pill.querySelector('[data-lp-diet-coke-cart-count]');
    if (badge && typeof count === 'number') {
      badge.textContent = count;
    }

    pill.classList.add('is-visible', 'is-bumping');
    window.setTimeout(function () {
      pill.classList.remove('is-bumping');
    }, 220);
  }

  function setButtonState(button, state, label) {
    if (!button) return;
    if (!button.dataset.lpDietCokeOriginalLabel) {
      button.dataset.lpDietCokeOriginalLabel = button.textContent.trim();
    }

    if (state === 'loading') {
      button.disabled = true;
      button.textContent = label || 'Adding';
    } else if (state === 'added') {
      button.disabled = false;
      button.textContent = label || 'Added';
      window.setTimeout(function () {
        button.textContent = button.dataset.lpDietCokeOriginalLabel;
      }, 1600);
    } else {
      button.disabled = false;
      button.textContent = button.dataset.lpDietCokeOriginalLabel;
    }
  }

  function refreshCartPill() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      })
      .then(function (cart) {
        showCartPill(cart.item_count);
      })
      .catch(function () {
        showCartPill();
      });
  }

  function getBundlePayload(form) {
    var rows = form.querySelectorAll('[data-lp-diet-coke-line-item]');
    var variantIds = [];
    var handles = [];
    var quantities = [];

    rows.forEach(function (row) {
      var idField = row.querySelector('[data-lp-diet-coke-line-id]');
      var quantityField = row.querySelector('[data-lp-diet-coke-line-quantity]');
      var id = idField && idField.value;
      var quantity = quantityField && quantityField.value ? parseInt(quantityField.value, 10) : 1;

      if (id) {
        variantIds.push(String(id).trim());
        handles.push(row.getAttribute('data-lp-diet-coke-line-handle') || '');
        quantities.push(Number.isNaN(quantity) ? 1 : quantity);
      }
    });

    return {
      variantIds: variantIds,
      handles: handles,
      quantities: quantities
    };
  }

  function submitAddForm(form) {
    var button = form.querySelector('[data-lp-diet-coke-add-button]');
    var isBundleForm = form.hasAttribute('data-lp-diet-coke-bundle-form');

    setButtonState(button, 'loading', form.getAttribute('data-lp-diet-coke-loading-label') || 'Adding');

    if (isBundleForm) {
      var payload = getBundlePayload(form);
      if (!payload.variantIds.length) {
        setButtonState(button, 'idle');
        return Promise.resolve();
      }

      if (typeof window.addMultipleProducts === 'function') {
        var themeAddResult = window.addMultipleProducts(payload.variantIds, payload.handles, payload.quantities, false, false);

        if (themeAddResult === false) {
          setButtonState(button, 'idle');
          return Promise.resolve();
        }

        if (themeAddResult && typeof themeAddResult.then === 'function') {
          return themeAddResult
            .then(function () {
              setButtonState(button, 'added', form.getAttribute('data-lp-diet-coke-added-label') || 'Added');
              return refreshCartPill();
            })
            .catch(function () {
              setButtonState(button, 'idle');
            });
        }

        window.setTimeout(function () {
          setButtonState(button, 'added', form.getAttribute('data-lp-diet-coke-added-label') || 'Added');
          refreshCartPill();
        }, 600);

        return Promise.resolve();
      }

      var items = payload.variantIds.map(function (id, index) {
        return {
          id: Number(id),
          quantity: payload.quantities[index] || 1
        };
      });

      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart add failed');
          return response.json();
        })
        .then(function (result) {
          document.dispatchEvent(new CustomEvent('lp-diet-coke:cart-add', { detail: result }));
          setButtonState(button, 'added', form.getAttribute('data-lp-diet-coke-added-label') || 'Added');
          return refreshCartPill();
        })
        .catch(function () {
          setButtonState(button, 'idle');
        });
    }

    var formData = new FormData(form);

    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function (item) {
        document.dispatchEvent(new CustomEvent('lp-diet-coke:cart-add', { detail: item }));
        setButtonState(button, 'added', form.getAttribute('data-lp-diet-coke-added-label') || 'Added');
        return refreshCartPill();
      })
      .catch(function () {
        setButtonState(button, 'idle');
        form.submit();
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-lp-diet-coke-add-form]');
    if (!form || !window.fetch || !window.FormData) return;
    event.preventDefault();
    submitAddForm(form);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lp-diet-coke-bundle-click]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var form = button.closest('[data-lp-diet-coke-bundle-form]');
    if (!form || !window.fetch || !window.FormData) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    submitAddForm(form);
  }, true);

  function init(root) {
    initTicker(root);
    initReveal(root);
    initFizz(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
